<h1 mat-dialog-title>Wybierz lokalizacje</h1>
<div mat-dialog-content>
	<div class="mb-3">
		<ng-select
			id="location"
			name="location"
			appendTo="body"
			class="custom-ng-select"
			[(ngModel)]="data.optionalTripLocations"
			placeholder="(wybierz)"
			required
		>
			<ng-option *ngFor="let item of data.locations" [value]="item"> {{ item.name }}</ng-option>
		</ng-select>
	</div>
</div>

<div class="d-flex justify-content-end" mat-dialog-actions>
	<button class="me-3" color="primary" mat-raised-button [mat-dialog-close]="data">Dodaj</button>
	<button mat-raised-button color="warn" (click)="onNoClick()">Zamknij</button>
</div>
